module.exports = __webpack_public_path__ + "img/2e45a11.jpg";